// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Image(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Image" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 4H2V20H22V4ZM5 16H19L14.1875 8L10.7422 13.7969L8.5 9.77778L5 16Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Image.js.map